import { useSuspenseQuery, type UseSuspenseQueryResult } from '@tanstack/react-query';

import { fetchOddsGridData, getOddsGridCacheKey } from '../api/cx-api.service';
import { type OddsGridProps, type OddsGridResponseData } from '../types';
import { overrideBookiesToCodes } from '../utils';

export const useQuery = ({
  dataApiEndpoint,
  ...queryArgs
}: OddsGridProps): UseSuspenseQueryResult<OddsGridResponseData | null> => {
  // The shared api-service (and cache key) speak plain bookmaker codes; the rich
  // `{ code, priority }[]` ordering shape is client-side only, so flatten to codes here.
  const apiArgs = { ...queryArgs, overrideBookies: overrideBookiesToCodes(queryArgs.overrideBookies) };

  return useSuspenseQuery<OddsGridResponseData | null>({
    queryFn: async () => {
      const result = await fetchOddsGridData(dataApiEndpoint, apiArgs, {
        logger: console,
      });

      // If the result is an error response, throw an error that can be caught by error boundaries
      if (result && 'error' in result) {
        throw new Error(result.message);
      }

      // The grid response carries inline bookmaker branding/offer click-out URLs that the shared
      // api-service type does not model (it stays minimal for other modules). odds-grid asserts
      // the richer contract here.
      return result as OddsGridResponseData | null;
    },
    queryKey: getOddsGridCacheKey(apiArgs),
  });
};
